import { render, staticRenderFns } from "./UserListSelectorDialog.vue?vue&type=template&id=88c53540&scoped=true&"
import script from "./UserListSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./UserListSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserListSelectorDialog.vue?vue&type=style&index=0&id=88c53540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c53540",
  null
  
)

export default component.exports